import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";
import { useState } from "react";

const Inputz = ({
  iconL,
  focusL,
  iconR,
  focusR,
  iconClear,
  hovericonClear,
  iconOn,
  iconOff,
  onChange = () => {},
  placeholder,
  permanentPlaceholder,
  className,
  buttonIcon,
  buttonHoverIcon,
  buttonLabel,
  buttonClass,
  value,
  name,
  counter,
  textCounter,
  disable,
  type = "text",
  error = false,
  numbersOnly = false,
  alphabetsOnly = false,
  /** Letters, digits, underscore only (align with `isUsernameValid` in auth/validation.js). */
  usernameSlug = false,
  alphabetsWithSpace = false,
  /** Unicode letters/marks, spaces, and common name punctuation (hyphen, apostrophe, period, ·). */
  internationalName = false,
  counterClassname,
  onBlur = () => {},
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const toggleFocus = (state) => setIsFocused(state);

  const handleClearInput = () => {
    onChange({ name: name, value: "" });
    setIsHovered(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    if (numbersOnly && !/^\d*$/.test(value)) {
      return;
    }

    if (alphabetsOnly && !/^[a-zA-Z]*$/.test(value)) {
      return;
    }

    if (usernameSlug && !/^[a-zA-Z0-9_]*$/.test(value)) {
      return;
    }

    if (alphabetsWithSpace && !/^[a-zA-Z\s]*$/.test(value)) {
      return;
    }

    if (
      internationalName &&
      !/^[\p{L}\p{M}\s.'’\-\u00B7]*$/u.test(value)
    ) {
      return;
    }

    if (!disable && (!textCounter || value.length <= textCounter)) {
      onChange(e.target);
    }
  };

  const handleToggle = () => {
    if (type === "password") {
      setShowPassword(!showPassword);
    }
    setIsToggled(!isToggled);
  };

  const isButtonVisible = !!buttonIcon;
  const showToggleIcon = iconOn && iconOff;
  const inputType =
    type === "password" ? (showPassword ? "text" : "password") : type;

  return (
    <div
      className={`input-icon-box ${isFocused ? `focused ${className}` : ""}  ${
        isButtonVisible ? "with-button" : ""
      } ${error ? "input-error" : ""} ${disable ? "disabled" : ""}`}
    >
      <span className="icon left-icon">
        <SvgIcn name={isFocused && focusL ? focusL : iconL} />
      </span>

      <div className={`input-container ${className}`}>
        {permanentPlaceholder && (
          <span className="permanent-placeholder">{permanentPlaceholder}</span>
        )}
        <input
          type={inputType}
          onFocus={() => toggleFocus(true)}
          onBlur={(e) => {
            toggleFocus(false);
            onBlur(e);
          }}
          className="input"
          placeholder={placeholder}
          value={value}
          name={name}
          onChange={handleInputChange}
          disabled={disable}
        />
      </div>

      {textCounter && (
        <span className={`counter ${counterClassname}`}>
          {textCounter - value?.length || textCounter}
        </span>
      )}

      {value && counter && (
        <span className={`counter ${counterClassname}`}>{counter}</span>
      )}

      {showToggleIcon ? (
        <span className="icon right-icon" onClick={handleToggle}>
          <SvgIcn name={isToggled ? iconOn : iconOff} />
        </span>
      ) : value && iconClear ? (
        <span
          className="icon right-icon"
          onClick={handleClearInput}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <SvgIcn name={isHovered ? hovericonClear : iconClear} />
        </span>
      ) : (
        iconR && (
          <span className="icon right-icon">
            <SvgIcn name={isFocused && focusR ? focusR : iconR} />
          </span>
        )
      )}
      {isButtonVisible && (
        <div
          className={`button-icon ${buttonClass}`}
          onMouseEnter={() => setIsButtonHovered(true)}
          onMouseLeave={() => setIsButtonHovered(false)}
          onClick={() => console.log(buttonLabel)}
        >
          <SvgIcn name={isButtonHovered ? buttonHoverIcon : buttonIcon} />
          {buttonLabel && <span>{buttonLabel}</span>}
        </div>
      )}
    </div>
  );
};

export default Inputz;
